import { useTranslation } from 'react-i18next';
import { Alert, Stack, Typography } from '@mui/material';
import { Modal } from '../../Modal';
import type { StartupStepProps } from '../StartupWizard.types';

export const CloseAcBreakerStep = ({ onNext, isMobile = false }: StartupStepProps) => {
  const { t } = useTranslation('startupWizard');

  return (
    <Modal
      isOpen
      title={t('closeAcBreaker.title')}
      maxWidth="md"
      isMobile={isMobile}
      onCancel={onNext}
      cancelButtonTitle={t('closeAcBreaker.skip')}
      cancelButtonAlign="left"
      data-testid="close-ac-breaker-modal"
    >
      <Stack spacing={3} pt={1}>
        <Alert severity="warning">{t('closeAcBreaker.description')}</Alert>
        <Typography color="text.secondary">{t('closeAcBreaker.waiting')}</Typography>
      </Stack>
    </Modal>
  );
};
